const pt = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Nome da fonte de descoberta',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'ID do usuário',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'URL do Service Now',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Senha',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'URL inválido',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Frequência de descoberta',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Solicite aos usuários que respondam a perguntas de autenticação baseada em conhecimento (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Descubra seus aplicativos e cargas de trabalho por meio de uma dessas fontes de descoberta conhecidas. Você terá acesso a benefícios como detalhes pré-preenchidos, recomendações priorizadas e uma visão completa do status de integração.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Voltar',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Descoberta de configuração',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Em breve…',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Saiba mais',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Insira as credenciais do aplicativo para estabelecer uma conexão. Quando a conexão for bem-sucedida, você poderá importar dados.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Algo deu errado ao carregar a página.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Tente atualizar ou verifique mais tarde. Se o problema persistir, entre em contato com o administrador.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Recarregar',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Configurações de conexão',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Classes de CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Mapeamento de atributos',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Detalhes da conexão',
  'INTEGRATIONS.BUTTON.SAVE': 'Salvar',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Selecionar',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Criar conexão',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Usar esta conexão',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'O ServiceNow foi salvo.',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Sua conexão com a fonte de descoberta ServiceNow foi testada e salva com sucesso. Importe dados para finalizar a configuração de descoberta. Você pode pular…',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importar ativos',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Pular por enquanto',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Após o início, não será possível cancelar a importação',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Seguir orientações',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Selecionar conexão existente',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Nome da conexão',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Descobrimos {total, plural, one {uma} other {#}} configuração de conexão existente:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Iniciar importação',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importando dados de arquivo do Excel. Aguarde…',
  'INTEGRATIONS.TRY.AGAIN': 'Tente novamente',
  'INTEGRATIONS.CLOSE': 'Fechar',
  'INTEGRATIONS.ERROR.CONNECTION': 'Houve um erro de conexão. Tente novamente.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Você pode sair da página enquanto espera. Notificaremos você quando o processo terminar.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Importar fonte de descoberta',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importe a fonte de descoberta de um arquivo',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Baixar arquivo de amostra',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Nome da fonte de descoberta',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Insira o nome do arquivo',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Insira um nome válido. Somente letras, números e símbolos selecionados são permitidos.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Carregando…',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continuar',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Estes são os primeiros 10 registros do arquivo XLSX carregado.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Falta o cabeçalho obrigatório',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Erros de coluna foram detectados',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Corrija os problemas antes de continuar com a importação de dados.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Excluir da importação',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Confirmação de integração do aplicativo',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Identificamos o tipo de aplicativo. Confirme se este é o tipo de aplicativo correto que você quer integrar.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'O tipo de aplicativo que será integrado é {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Não, selecionar em uma lista de aplicativos',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'Sim, quero integrar',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integrações',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Adicionar integração',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH':
    'Nenhum resultado foi encontrado para',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Não',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX':
    'integrações foram encontradas.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'Não há integrações ocultas disponíveis.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Aplicativos descobertos',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Proprietário:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Última descoberta em',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Falha na conexão',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Usuários têm acesso',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Fonte de descoberta',
  'INTEGRATIONS.BUTTON.ENABLE': 'Ativar',
  'INTEGRATIONS.BUTTON.DISABLE': 'Desativar',
  'INTEGRATIONS.ENABLING': 'Ativando',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Descoberta',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Carregar novamente',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Integrar',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Ocultar',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Mostrar',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL':
    'Guias de configuração de descoberta',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Descartar alterações não salvas?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Você tem alterações não salvas. As alterações serão perdidas se você continuar.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Descartar alterações',
  'INTEGRATIONS.BUTTON.CANCEL': 'Cancelar',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Houve um erro ao salvar',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Voltar para a página anterior',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Ícone do aplicativo',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Executar manualmente',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Houve uma falha na desativação',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE':
    'Houve uma falha na ativação',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'A desativação foi realizada.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'A ativação foi realizada.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Outra importação está em andamento.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Os ativos estão sendo importados por outro processo. Tente novamente mais tarde.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'Houve uma falha na importação',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Importação de ativos do ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Você pode sair da página enquanto espera. Notificaremos você quando o processo terminar.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Adicionar nova linha de mapeamento de atributos',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Adicionar atributo',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Em branco)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Excluir este mapeamento',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Campo do ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Campo do Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Pesquisar atributo do ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT':
    'Pesquisar atributo do Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Personalizado)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Houve uma falha ao salvar',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Configuração de programação',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'às {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Repetir no(a)',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Repetir em dias',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Repetir a cada',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Insira o intervalo',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Intervalo de repetição em número de dias, semanas ou meses',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Dia',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Semana(s)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Mês',
  'INTEGRATIONS.DAYS.SUN': 'Dom',
  'INTEGRATIONS.DAYS.MON': 'Seg',
  'INTEGRATIONS.DAYS.TUE': 'Ter',
  'INTEGRATIONS.DAYS.WED': 'Qua',
  'INTEGRATIONS.DAYS.THU': 'Qui',
  'INTEGRATIONS.DAYS.FRI': 'Sex',
  'INTEGRATIONS.DAYS.SAT': 'Sáb',
  'INTEGRATIONS.BUTTON.DISABLING': 'Desativando',
  'INTEGRATIONS.BUTTON.SAVED': 'Salvo',
  'INTEGRATIONS.BUTTON.SAVING': 'Salvando',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    'Tem certeza de que quer desativar ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Após a desativação da fonte de descoberta, a importação de ativos será interrompida, e você não poderá configurar a fonte.',
  'INTEGRATIONS.DISCOVERY.HERE': 'aqui',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'A fonte de descoberta foi criada, mas houve uma falha na conexão com o ServiceNow. Para começar a importar ativos, atualize os detalhes da conexão na página de configuração da fonte de descoberta ',
};

export default pt;
